'use client'
import { Image } from '@/components'
import { URL_ICON } from '@/constants/ui'
import { Box, Stack, Typography } from '@mui/material'
import Link from 'next/link'

interface ReviewHeaderProps {
  title?: string | React.ReactNode
  note?: string | React.ReactNode
  subtitle?: string | React.ReactNode
  showLogo?: boolean
  alignment?: 'center' | 'left' | 'right'
}

export const ReviewHeader = ({
  title = (
    <>
      Đánh giá sản phẩm
      <br />
      Hoàn tiền từ 6% - 18%
    </>
  ),
  subtitle,
  showLogo = true,
  note,
  alignment = 'center',
}: ReviewHeaderProps) => {
  return (
    <Stack
      spacing={2}
      sx={{
        width: '100%',
        alignItems: alignment,
      }}
    >
      {/* Logo */}
      {showLogo && (
        <Box sx={{ mb: 2 }}>
          <Link href={'/'} aria-label="Logo Hydra">
            <Image
              src={URL_ICON + 'logo-full-content.png'}
              alt="Logo"
              sx={{
                width: { xs: '100px', sm: '120px', lg: '150px' },
              }}
            />
          </Link>
        </Box>
      )}
      <Box>
        {/* Title */}
        {title && (
          <Typography
            variant="h2"
            sx={{
              fontSize: {
                xs: '28px',
                md: '32px',
                lg: '2.5rem',
              },
              fontWeight: 600,
              textAlign: alignment,
              lineHeight: 1.5,
            }}
          >
            {title}
          </Typography>
        )}
        {/* Note */}
        {note && (
          <Typography
            sx={{
              fontSize: {
                xs: '14px',
                md: '16px',
              },
              fontWeight: 300,
              textAlign: alignment,
              lineHeight: 1.5,
              fontStyle: 'italic',
              color: '#252422',
            }}
          >
            {note}
          </Typography>
        )}
      </Box>

      {/* Subtitle */}
      {subtitle && (
        <Typography
          sx={{
            fontSize: {
              xs: '14px',
              md: '16px',
            },
            fontWeight: 300,
            textAlign: alignment,
            lineHeight: 1.5,
            color: '#252422',
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Stack>
  )
}
